<template>
    <div>
        <values ref="values" />

        <b-overlay :show="wait">

        <b-table ref="variables" class="factors" style="font-size: 10pt;" small sort-by="ind"
            :fields="attrs_fields" :items="items"
            selectable select-mode="single" selected-variant="primary" v-on:row-selected="select_attr"
        >

            <template v-slot:head(settings)>
                <base-icon name="settings" />
            </template>

            <template v-slot:cell(settings)="data">

                <b-button v-if="!data.item.not_editable" variant="outline-primary-dark" size="sm" @click="() => delete_one(data.item.id)">
                    <base-icon name="delete" />
                </b-button>

            </template>

            <template v-slot:cell(values)="data">
                <template v-if="data.item.values && data.item.values[0]">

                    <div v-if="data.item.type == 'str'" class="values-cell">
                        <div>{{ empty_value(data.item.values[0][0]) }}: {{ data.item.values[0][1] }},</div>
                        ...
                        <b-button class="transparent values-cell_open" size="sm" @click="() => show_values(data.item.values, data.item.not_empty_count)">
                            <base-icon name="Full - Short_open" size="md" />
                        </b-button>
                    </div>
                    <template v-else-if="data.item.type == 'bool'">
                        <div>{{ data.item.values[0][0] }}: {{ data.item.values[0][1] }},</div>
                        <div v-if="data.item.values[1]">{{ data.item.values[1][0] }}: {{ data.item.values[1][1] }}</div>
                    </template>

                </template>
            </template>

        </b-table>

        </b-overlay>
    </div>
</template>

<script>
import api from '../../../../../../api';
import attrs from '../../../../../../api/attrs';
import values from "./values.vue"

export default {
    props :
	{
		data : Array,
        is_analogues : { type : Boolean, default : () => false },
	},

    components :
    {
        values
    },

    data()
    {
        return {
            attrs : null,
            wait : true,
            items : []
        }
    },

    computed :
    {
        attrs_fields()
        {
            let fields = [
                { key : "name", label : "Ценообразующий фактор" },
                { key : "not_empty_count", label : `Количество ${this.is_analogues ? 'объектов-аналогов' : 'объектов оценки'}` },
                { key : "values", label : "Обобщенные значения" },
                { key : "min", label : "Минимум" },
                { key : "median", label : "Медиана" },
                { key : "average", label : "Среднее" },
                { key : "weighted_average", label : "Средневзвешенное" },
                { key : "max", label : "Максимум" },
            ]

            if (!this.not_editable && this.check_roles([ 'model' ]))
            {
                fields.unshift({
                    key : "settings",
                    label : "",
                    thClass: "cell_settings_head",
                    thStyle: "width: 64px;",
                    tdClass: "cell_settings"
                })
            }

            return fields
        }
    },

    watch :
    {
        data()
        {
            if (this.attrs == null)
            {
                attrs.get(this).then((res) => {
                    this.attrs = res.attrs
                    this.add_initial_attrs()
                })
            }
            else
            {
                this.add_initial_attrs()
            }
        }
    },

    methods :
    {
        check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        add_initial_attrs()
        {
            this.items = this.data.map((_stat) => {
                const attr = this.attrs.find(_attr => _attr.id == _stat.id)

                const stat = this.is_analogues ? _stat.analogues : _stat.objects

                attr.value = stat.weighted_average
                attr.count = stat.count
                attr.not_editable = _stat.not_editable

                let histogram

                if(attr.reference == null)
                {
                    attr.min = stat.min
                    attr.max = stat.max
                    attr.average = stat.average
                    attr.weighted_average = stat.weighted_average
                    attr.median = stat.median

                    histogram = []

                    // response.histogram_count.forEach(
                    // 	elem =>
                    // 	{
                    // 		const label = attr.type == "bool" ? ( elem[0] ? "Да" : "Нет" ) : elem[0]

                    // 		histogram.push([ label, elem[1] ])
                    // 	})

                    histogram = stat.histogram_count
                }
                else
                {
                    attr.min = api.format_reference(attr.reference, stat.min)
                    attr.max = api.format_reference(attr.reference, stat.max)
                    attr.average = api.format_reference(attr.reference, stat.average)
                    attr.weighted_average = api.format_reference(attr.reference, stat.weighted_average)
                    attr.median = api.format_reference(attr.reference, stat.median)

                    histogram = []

                    stat.histogram_count?.forEach(elem => histogram.push([ api.format_reference(attr.reference, elem[0]), elem[1] ]))
                }

                attr.histogram = histogram

                attr.values = histogram

                attr.not_empty_count = histogram?.reduce((sum, [ value, count ]) => value !== null ? sum + count : sum, 0)

                return attr
            })

            this.wait = false
        },

        show_values(attr_values, not_empty_count)
        {
            this.$refs.values.execute(attr_values, not_empty_count)
        },

        select_attr(attrs)
		{
			this.$emit("refresh_plot", attrs[0])
		},

        delete_one(attr_id)
		{
			const message = "Вы действительно хотите удалить ценообразующий фактор из расчета?"

			this.$bvModal.msgBoxConfirm(message,
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
							this.delete_attr(attr_id)
					})
		},

        delete_attr(attr_id)
		{
			this.$emit("delete_attr", attr_id)
		},

        empty_value(value)
        {
            return api.format_value_empty(value)
        }
    }
}
</script>

<style scoped>
* >>> .cell_settings_head
{
	text-align: center;
}

* >>> .factors td:not(.cell_settings), div
{
    text-overflow: ellipsis;
    overflow: hidden;
}

* >>> .factors
{
    table-layout: fixed;
}

.values-cell
{
    position: relative;
    overflow: unset;
}

.values-cell_open
{
    padding: 0;
    position: absolute;
    right: -16px;
    top: -8px;
    opacity: .5;
}
</style>
